'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { IconError, IconClose } from '../icons/index.js';
import IconSuccess from '../icons/IconSuccess.js';
import styles from './Toast.module.css.js';

var EVENT_NAME = 'VNW_TOAST_SHOW';
var TOAST_DISPLAY_MAXIMUM = 3;
var TOAST_TYPE_SUCCESS = 'success';
var TOAST_TYPE_ERROR = 'error';
var TOAST_TIMEOUT = 5000;
var TOAST_REMAINING = 3000;
function Toast () {
    var _a = useState([]), toastList = _a[0], setToastList = _a[1];
    var _b = useState(), intervalId = _b[0], setIntervalId = _b[1];
    var deleteToast = function (index) {
        var deletedToastList = toastList.filter(function (_item, itemIndex) {
            return itemIndex !== index;
        });
        setToastList(deletedToastList);
    };
    var pauseTimeOut = function () {
        clearTimeout(intervalId);
    };
    var resumeTimeOut = function () {
        var interval;
        if (toastList.length > 0) {
            interval = setTimeout(function () {
                deleteToast(0);
            }, TOAST_REMAINING);
            setIntervalId(interval);
        }
    };
    useEffect(function () {
        if (toastList.length > TOAST_DISPLAY_MAXIMUM) {
            deleteToast(0);
            return;
        }
        var interval;
        if (toastList.length > 0) {
            interval = setTimeout(function () {
                deleteToast(0);
            }, TOAST_TIMEOUT);
            setIntervalId(interval);
        }
        return function () {
            interval && clearTimeout(interval);
        };
    }, [toastList]);
    useEffect(function () {
        var showToast = function (e) {
            var message = e.detail.message;
            var title = e.detail.title;
            var type = e.detail.type;
            setToastList(__spreadArray(__spreadArray([], toastList, true), [
                {
                    title: title,
                    message: message,
                    type: type
                }
            ], false));
        };
        window.addEventListener(EVENT_NAME, showToast);
        return function () {
            window.removeEventListener(EVENT_NAME, showToast);
        };
    }, [toastList]);
    return (React__default.createElement("div", { className: styles.container }, toastList.map(function (toast, index) {
        return (React__default.createElement("div", { className: styles.toast, key: index, onMouseOver: pauseTimeOut, onMouseLeave: resumeTimeOut },
            React__default.createElement("div", { className: styles.messageContainer },
                React__default.createElement("div", { className: styles.icon },
                    toast.type === TOAST_TYPE_ERROR && (React__default.createElement(IconError, { width: 20, height: 20, className: styles.errorIcon })),
                    toast.type === TOAST_TYPE_SUCCESS && React__default.createElement(IconSuccess, null)),
                React__default.createElement("div", { className: styles.title }, toast.title),
                React__default.createElement("div", { onClick: function () { return deleteToast(index); } },
                    React__default.createElement(IconClose, { width: 14, height: 14, className: styles.closeIcon }))),
            React__default.createElement("div", { className: styles.message }, toast.message)));
    })));
}
function showToast(title, message, type) {
    if (type === void 0) { type = TOAST_TYPE_SUCCESS; }
    if (typeof window === 'undefined') {
        return;
    }
    var event = new CustomEvent(EVENT_NAME, {
        detail: {
            title: title,
            message: message,
            type: type
        }
    });
    window.dispatchEvent(event);
}

export { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, Toast as default, showToast };
//# sourceMappingURL=index.js.map
